import LegalEntityBranchModel from "@/models/LegalEntityBranchModel";
import axiosHelper from "../axiosHelper";
import LegalEntityModel from "@/models/LegalEntityModel";
import { AxiosInstance } from "axios";

export default class LegalEntityApiHelper {

    private _url: string = '/api/legalentities';
    private _axiosInstance: AxiosInstance;

    constructor(jwt: string) {
        this._axiosInstance = axiosHelper.createInstance(jwt);
    }

	async getExecutiveBranchesAsync(): Promise<Array<LegalEntityBranchModel> | null> {
        try {         

            const response = await this._axiosInstance.get<Array<LegalEntityModel>>(`${this._url}/executives`);
            if (!response.data?.length) {
                return new Array<LegalEntityBranchModel>();
            }
        
            const l = new Array<LegalEntityBranchModel>();
        
            response.data.forEach(legalEntity => {
                if (legalEntity?.branches?.length) {
                    legalEntity.branches.forEach(b => {
                        l.push(new LegalEntityBranchModel({
                            id: b.id,
                            name: `${legalEntity.name}: ${b.name}`
                        }));
                    });
                }
            });
        
            return l;            
        } catch (e: any) {
            console.error('Error loading executuive entities branches list', e);
            return null;
        }        
	}
}